// extracted by mini-css-extract-plugin
export default {"modal":"Home_modal__yKbRv"};